import { authorizedHttpGet } from "../../api/httpCalls";
import EmptyView from "../EmptyView";
import LeftNav from "../LeftNav";
import Loader from "../Loader";
import '../styles/Bios.css';
import React, { useState, useEffect, useRef } from "react";
import urls from '../../api/urls.json'
import About1 from "./bios/About1";
import About2 from "./bios/About2";
import PageModal from "../modals/PageModal";
import { useLocation, useNavigate } from "react-router-dom";


const Bios = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const authToken = localStorage.getItem('authToken');
    const isOtpVerified = localStorage.getItem('verificationPassed');
    if (!authToken || !isOtpVerified) {
        sessionStorage.setItem('redirectUrl', location.pathname)
        navigate('/login')
    }

    const [currentView, setCurrentView] = useState("About 1");
    const [isLoading, setIsLoading] = useState(false);
    const [appName, setAppName] = useState(localStorage.getItem('appName'))
    const [reviews, setReviews] = useState([]);
    const [page, setPage] = useState(1);
    const totalPages = useRef(0);
    const [togglePageModal, setTogglePageModal] = useState(false);

    const handleLeftNavAppChange = (name) => {
        setAppName(name);
        setPage(1);
    }

    const handleViewChange = (view) => {
        setCurrentView(view);
        setPage(1);
    }

    const fetchData = async (url) => {
        setReviews([])
        setIsLoading(true);
        let messageType = currentView === 'About 1' || currentView === 'About 2' ? 'about' : 'introduction'
        let response = await authorizedHttpGet(url, { "page": page, "message_type": messageType })
        if (response.status) {
            if (currentView === 'About 1' || currentView === 'Icebreaker 3') {
                let reviewNew = []
                response.data.reviews.forEach(item => {
                    reviewNew.push({ ...item, oldText: item.text })
                })
                setReviews(reviewNew)
            } else {
                if (response.data.review_data !== null) {
                    setReviews([response.data.review_data])
                }
            }
            totalPages.current = response.data.total_pages
        }
        setIsLoading(false);
    }

    const handleInputOneChange = (e, review_id) => {
        setReviews(reviews.map(item => {
            if (item.review_id === review_id) {
                return { ...item, text: e.target.value }
            }
            return item
        }));
    }

    const handleReset = (reviewId) => {
        setReviews(reviews.map(item => {
            if (item.review_id === reviewId) {
                return { ...item, text: item.oldText }
            }
            return item
        }));
    }

    const handlePageChangeAbountOne = (page) => {
        setPage(page)
    }

    const afterSave = async () => {
        if (currentView === 'About 1' || currentView === 'Icebreaker 3') {
            fetchData(urls.GET_REVIEW_LIST);
        } else if (currentView === 'About 2' || currentView === 'Icebreaker 4') {
            fetchData(urls.GET_REVIEW_INDIVIDUAL);
        }
    }

    useEffect(() => {
        if (currentView === 'About 1' || currentView === 'Icebreaker 3') {
            fetchData(urls.GET_REVIEW_LIST);
        } else if (currentView === 'About 2' || currentView === 'Icebreaker 4') {
            fetchData(urls.GET_REVIEW_INDIVIDUAL);
        }
    }, [appName, currentView, page]);

    const goToPage = (page) => {
        setPage(page)
        setTogglePageModal(false)
    }

    return (
        <div className="App">
            <LeftNav handleLeftNavAppChange={handleLeftNavAppChange} tabName={'Bios'} />
            {isLoading && <Loader />}
            {togglePageModal && <PageModal page={page} closeModal={() => setTogglePageModal(false)} goToPage={goToPage} />}
            <div className="mainDivBios">
                <div className="headerText">
                    <div className="pageNumber" onClick={() => setTogglePageModal(true)}>
                        <span className="selectedSpan">{page}</span>
                        <span className="unSelectedSpan">{totalPages.current}</span>
                    </div>
                    <div className="pageNumber tabDetails">
                        <span className={currentView === 'About 1' ? 'selectedSpan' : 'unSelectedSpan'} onClick={() => handleViewChange('About 1')}>About</span>
                        {/* <span className={currentView === 'About 2' ? 'selectedSpan' : 'unSelectedSpan'} onClick={() => handleViewChange('About 2')}>About 2</span> */}
                        <span className={currentView === 'Icebreaker 3' ? 'selectedSpan' : 'unSelectedSpan'} onClick={() => handleViewChange('Icebreaker 3')}>Icebreaker</span>
                        {/* <span className={currentView === 'Icebreaker 4' ? 'selectedSpan' : 'unSelectedSpan'} onClick={() => handleViewChange('Icebreaker 4')}>Icebreaker 4</span> */}
                    </div>
                </div>
                {
                    reviews.length > 0 && currentView === 'About 1' || currentView === 'Icebreaker 3' ? <About1 reviews={reviews} page={page} handleInputOneChange={handleInputOneChange} totalPages={totalPages} handlePageChangeAbountOne={handlePageChangeAbountOne} afterSave={afterSave} handleReset={handleReset} currentView={currentView} /> : null
                }
                {
                    reviews.length > 0 && currentView === 'About 2' || currentView === 'Icebreaker 4' ? <About2 reviews={reviews} page={page} handleInputOneChange={handleInputOneChange} totalPages={totalPages} handlePageChangeAbountOne={handlePageChangeAbountOne} afterSave={afterSave} /> : null
                }
                {
                    reviews.length === 0 && <EmptyView />
                }
            </div>
        </div>
    )
};

export default Bios;